import '../scss/not-found.scss';

import menuModule from "./modules/menu.js";
import footerModule from "./modules/footerModule.js";

(function ($) {
    $(document).ready(function () {
        menuModule.init();
        footerModule.init();
    });

}(jQuery));



